import Modal from "react-bootstrap/Modal";
import React from "react";


const PopUp = ({
                 propTitle = '',
                 propShow = false,
                 propSize = 'xl',
                 setShow,
                 children,
                 propDialogClassName = undefined
               }) => {

  const handleClose = () => setShow(false);

  return (
      <>
        <Modal
            show={propShow}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            size={propSize}
            centered
            dialogClassName={propDialogClassName}
        >
          <Modal.Header closeButton closeVariant={"white"}>
            <Modal.Title>{propTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {children}
          </Modal.Body>
        </Modal>
      </>

  );
}

export default PopUp;